export const SCREENS = {
  FIRST_SCREEN: 1,
  INFO: 1,
  SCHEDULED_SERVICES: 2,
  REMARKS: 3,
  ORDER: 4,
  THANK_YOU: 5,
  LAST_SCREEN: 6,
  SUPPORT: 7,
};
